(function () {

  'use strict';

  /**
   * @author Chester Rivas
   */
  angular.module('eclipseApp.components')

    .directive('uteGlobalSearch', ['uteModal', '$rootScope', 'env', '$http', '$filter', 'uteLocale', function (uteModal, $rootScope, env, $http, $filter, uteLocale) {

      return {
        restrict: 'AE',
        replace: true,
        scope: {
          service: '@',
          dimension: '@'
        },
        template: '<a ng-click="openSearch()" title="Search" ute-tracking="header:opensearch"><i class="ute-icon-search"></i><span class="hidden-xs"><ins translate="global.cta.search"></ins></span></a>',
        controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {

          $scope.results = {};
          $scope.results.quicklinks = [];
          $scope.results.related = {};

          // Set default max results to show
          $scope.max = {
            results: 5,
            quicklinks: 5
          };

          $scope.css = {
            formClass: ''
          };

          $scope.search = $('#' + $attrs.id).find('form').attr('action');

          // Central method to clear results from scope
          $scope.clearResults = function () {
            $scope.results.links = {};
            $scope.results.quicklinks = [];
            $scope.css.formClass = '';
          };

          $scope.onBlur = function () {
            $scope.clearResults();
          };

          var parentScope = $scope;

          /**
           * @description opens up a search modal
           */
          $scope.openSearch = function () {

            console.log('===================');
            console.log('OPEN SEARCH MODAL');
            console.log('===================');

            uteModal.open({
              templateUrl: 'modules/components/views/search.html',
              size: 'md',
              controller: ['$scope', function ($scope) {

                _.defaults($scope, parentScope);

                $scope.searchPlaceholderText = $filter('translate')('global.label.searchPlaceholder');
                //$scope.searchPlaceholderTxt = "working";

                // What Dimension search value should we use?
                //$scope.dimensionName = $attrs.configDimension;
                var dimension = $scope.dimension || 'Accessory_QuickLink';

                var service = $scope.service || '/assembler/json/pages/typeahead/globalEN?Ntk=global1';

                $scope.criteria = '';

                var baseDomain = '';
                // var baseDomain = 'http://142.146.172.51:8006';
                // var baseDomain = 'http://www.dev10.fido.ca';
                // var baseDomain = 'http://uatls.fido.ca';
                // var baseDomain = 'http://previewls.fido.ca';
                // test in dev 10,12, and 18

                if (location.hostname === 'localhost') {
                  console.log('> hardcoded to dev12 for locahost only');
                  baseDomain = 'http://www.dev12.fido.ca';
                }

                // Helper to build the url for the service calls
                $scope.getServiceUrl = function () {
                  //return baseDomain + service + '&Ntt=' + $scope.criteria + '&Dr=AND(Language_D:' + uteLocale.language + ',Province:' + uteLocale.province + ')'; // #prepforrefactor
                  return baseDomain + service + '&Ntt=' + $scope.criteria + '&Dr=AND(Language_D:' + uteLocale.language + ',Province:' + uteLocale.province + ')';
                };

                /**
                 * @name cancel
                 * @description close modal
                 */
                $scope.cancel = function () {
                  console.log('uteGlobalSearch > cancel');
                  uteModal.closeThisModal();
                };

                console.log('> search url:', $scope.getServiceUrl());

                $scope.$watch('criteria', function (newValue, oldValue) {

                  if (newValue.length > 3 && newValue !== oldValue) {

                    $http.get($scope.getServiceUrl())

                      .then(function (response) {

                        $scope.results.quicklinks = [];

                        //console.log('response.data:', response.data);

                        var resultData = response.data.typeaheadmainContent[0].contents[0].autoSuggest[0].dimensionSearchGroups;

                        _.each(resultData, function (data, i) {

                          var dim = response.data.typeaheadmainContent[0].contents[0].autoSuggest[0].dimensionSearchGroups[i];

                          console.log('Position: ' + i + ' [ ' + dim.dimensionName + ' #' + dim.dimensionSearchValues.length + ' ]');

                          if (dim.dimensionName === 'TypeAheadSupport') {

                            $scope.results.links = dim.dimensionSearchValues;
                            $scope.max.links = response.data.typeaheadmainContent[0].contents[0].autoSuggest[0].maxDim1Results;

                          } else if (dim.dimensionName !== 'TypeAheadSupport') {

                            var limit = response.data.typeaheadmainContent[0].contents[0].autoSuggest[0]['maxDim' + ( i + 1 ) + 'Results'];
                            var selection = dim.dimensionSearchValues.splice(0, limit);
                            $scope.results.quicklinks = $scope.results.quicklinks.concat(selection);

                          }

                        });

                        if ($scope.results.links.length > 0) {
                          $scope.css.formClass = 'rui-ngtypeahead-open';
                        }

                      }, function (response) {

                        console.log('error', response);

                      });

                  } else {

                    $scope.clearResults();

                  }

                });

              }]
            });
          };

        }]

      };

    }]);

})();
